import { createType } from 'framework/utils/createType';

export const NoahDevicesTabTypes = createType('rules', 'read-outs');
export type NoahDevicesTabType = typeof NoahDevicesTabTypes[number];
